var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import * as React from 'react';
import styled from 'styled-components';
import { useGlobalContext } from '../global';
import { ODIcon } from "../../icons";
import { ODHSpace } from "../layout";
export var ODButtonTheme;
(function (ODButtonTheme) {
    ODButtonTheme["Primary"] = "Primary";
    ODButtonTheme["PrimaryInvert"] = "PrimaryInvert";
    ODButtonTheme["Cancel"] = "Cancel";
    ODButtonTheme["Basic"] = "Basic";
})(ODButtonTheme || (ODButtonTheme = {}));
export var ODButtonSize;
(function (ODButtonSize) {
    ODButtonSize["Small"] = "Small";
    ODButtonSize["Normal"] = "Normal";
})(ODButtonSize || (ODButtonSize = {}));
var ButtonWrapper = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: ", ";\n  background-color: ", ";\n  cursor: ", ";\n  color: ", ";\n  font-size: ", ";\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n"], ["\n  border: ", ";\n  background-color: ", ";\n  cursor: ", ";\n  color: ", ";\n  font-size: ", ";\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  ", "\n"])), function (p) { return p.border; }, function (p) { return (p.disabled ? 'silver' : p.backgroundColor); }, function (p) { return (p.disabled ? 'not-allowed' : 'pointer'); }, function (p) { return p.textColor; }, function (p) { return p.textSize; }, function (p) { return p.extra || ''; });
var TextWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n"], ["\n  margin-top: ", ";\n  margin-bottom: ", ";\n"])), function (p) { return p.insetTop; }, function (p) { return p.insetBottom; });
var sizeConfig = (_a = {},
    _a[ODButtonSize.Small] = { textSize: '14px', insetTop: '6px', insetBottom: '7px' },
    _a[ODButtonSize.Normal] = { textSize: '16px', insetTop: '16px', insetBottom: '13px' },
    _a);
var disabledStyleProps = {
    backgroundColor: '#FAFBFB',
    color: '#8C9196',
    textColor: '#8C9196',
    border: '1px solid #F1F2F3',
};
export var ODButton = function (_a) {
    var _b;
    var children = _a.children, _c = _a.style, style = _c === void 0 ? {} : _c, props = __rest(_a, ["children", "style"]);
    // TODO: 우리의 컨텍스트를 제대로 정리하자. 테마가 어떻게 전파되어야 하는가?
    var convertThemeString = useGlobalContext().convertThemeString;
    var themeConfig = (_b = {},
        _b[ODButtonTheme.Primary] = {
            backgroundColor: convertThemeString('{{primary}}'),
            textColor: 'white',
            border: 0,
        },
        _b[ODButtonTheme.Primary] = {
            backgroundColor: convertThemeString('{{primary}}'),
            textColor: 'white',
            border: 0,
        },
        _b[ODButtonTheme.PrimaryInvert] = {
            backgroundColor: 'white',
            textColor: convertThemeString('{{primary}}'),
            border: "1px solid " + convertThemeString('{{primary}}'),
        },
        _b[ODButtonTheme.Cancel] = {
            backgroundColor: 'white',
            textColor: '#A21B00',
            border: "1px solid #BABFC3",
            extra: 'border-radius: 4px;'
            // extra: 'border-radius: 3px;',
        },
        _b[ODButtonTheme.Basic] = {
            backgroundColor: 'white',
            textColor: '#202223',
            border: "1px solid #BABFC3",
            extra: 'border-radius: 4px; box-shadow: `0px 1px 0px rgba(0, 0, 0, 0.05);',
        },
        _b);
    var theme = props.theme, size = props.size, fullWidth = props.fullWidth, onClick = props.onClick, _d = props.type, type = _d === void 0 ? 'button' : _d, _e = props.disabled, disabled = _e === void 0 ? false : _e, _f = props.rounded, rounded = _f === void 0 ? false : _f, otherProps = __rest(props, ["theme", "size", "fullWidth", "onClick", "type", "disabled", "rounded"]);
    var p = __assign(__assign({}, themeConfig[theme]), sizeConfig[size || ODButtonSize.Normal]);
    var roundedStyle = rounded ? { borderRadius: '4px' } : {};
    var styleMerged = fullWidth ? { width: '100%' } : {};
    var disableStyle = disabled ? disabledStyleProps : {};
    return (React.createElement(ButtonWrapper
    // @ts-ignore
    , __assign({ 
        // @ts-ignore
        type: type, disabled: disabled }, p, otherProps, { style: __assign(__assign(__assign(__assign({}, styleMerged), roundedStyle), style), disableStyle), onClick: onClick }),
        React.createElement(React.Fragment, null,
            props.icon &&
                React.createElement(React.Fragment, null,
                    React.createElement(ODIcon, { icon: props.icon }),
                    React.createElement(ODHSpace, { w: 5 })),
            React.createElement(TextWrapper, __assign({}, p), children))));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=ODButton.js.map